import  { useState,  useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getNewStatusFetch,
  putFinishStatusFetch,
} from "../../features/action/fetchStatus";

import { OrderHeader } from "../common/OrderHeader";
import { useSearch } from "../../context/SearchContext";
import { Button, search, sortDate } from "../../util/main";
import { Disigner } from "./Disigner";
import { Storage } from "./Storage";
import { ready } from "../../util/icon";
import { checkIsName } from "../../features/redux/authSlice";

const Manager = () => {
  const { manager} = useSelector(
    (state) => state.status
  ); 
  const isName = useSelector(checkIsName);
  
  const [filteredStatus, setFilteredStatus] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: "toDate", isAscending: false });
  const [confirmId, setConfirmId] = useState(null);
  const { searchQuery} = useSearch();
 const dispatch = useDispatch();

  const handleClickEnd = (id, order) => {
    setConfirmId({ id, order });
  };

  const handleConfirm = () => {
    dispatch(putFinishStatusFetch(confirmId.id));
    setConfirmId(null);
  };

  const isMoreThan2WeeksOld = (dateString) => {
    const [day, month, year] = dateString.split("/");
    const date = new Date(2000 + Number(year), Number(month) - 1, Number(day));
    const today = new Date();
    const twoWeeksInMs = 14 * 24 * 60 * 60 * 1000;
    const diff = today - date;
    return diff > twoWeeksInMs;
  };

  // Сортировка по дате завершения
  const handleToDate = (manualAscending) => {
    const isAscending =
      typeof manualAscending === "boolean"
        ? manualAscending
        : sortConfig.key === "toDate"
        ? !sortConfig.isAscending
        : false;
    setSortConfig({ key: "toDate", isAscending });
  };

  // Сортировка по дате начала
  const handleFromDate = (manualAscending) => {
    const isAscending =
      typeof manualAscending === "boolean"
        ? manualAscending
        : sortConfig.key === "fromDate"
        ? !sortConfig.isAscending
        : false;
    setSortConfig({ key: "fromDate", isAscending });
  };

  useEffect(() => {
    dispatch(getNewStatusFetch());
  }, [dispatch]);

  useEffect(() => {
    document.body.classList.add("no-scrollbar");
    document.documentElement.classList.add("no-scrollbar");
    return () => {
      document.body.classList.remove("no-scrollbar");
      document.documentElement.classList.remove("no-scrollbar");
    };
  }, []);

  useEffect(() => {
    let filteredResults = searchQuery
      ? search(manager, searchQuery)
      : manager;

    if (sortConfig.key) {
      filteredResults = sortDate(
        [...filteredResults],
        sortConfig.key,
        sortConfig.isAscending
      );
    }
    
    setFilteredStatus(filteredResults);
  }, [searchQuery, manager, sortConfig]);

  return (
    <div className="w-[100%]">
      {confirmId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl shadow-2xl p-6 flex flex-col items-center gap-4 min-w-[260px]">
            <p className="font-rubik text-[#7D7D7D] text-base">Close order <span className="font-semibold text-[#739D00]">#{confirmId.order}</span>?</p>
            <div className="flex gap-3">
              <button onClick={handleConfirm} className="px-5 py-1.5 bg-[#e6e6e6] hover:bg-[#739D00] text-[#7D7D7D] hover:text-white font-rubik rounded-lg transition-colors">Confirm</button>
              <button onClick={() => setConfirmId(null)} className="px-5 py-1.5 bg-[#e6e6e6] hover:bg-[#739D00] text-[#7D7D7D] hover:text-white font-rubik rounded-lg transition-colors">Cancel</button>
            </div>
          </div>
        </div>
      )}
     
        <div className="flex flex-col  mx-auto">
        {/* Заголовки */}
        <OrderHeader
          onFromDateClick={handleFromDate}
          onToDateClick={handleToDate}
          sortConfig={sortConfig}
        />
        <div className="rounded-xl mb-6">
          {filteredStatus.map((i) => {
            const isOld = isMoreThan2WeeksOld(i[sortConfig.key] || i.toDate);
            return (
              <div 
                key={i._id} 
                className={`flex flex-row h-[64px] mb-1 text-center rounded-[10px] border-solid border-[1px] ${
                  isOld ? 'bg-white border-[#dbdbdb] animate-pulse' : 'bg-white border-solid border-[#dbdbdb]'
                }`}
                style={isOld ? {
                  animation: 'pulse-red 2s ease-in-out infinite',
                  background: 'linear-gradient(90deg, #fff 0%, #ff000071 80%, #fff 100%)',
                  backgroundSize: '200% 100%'
                } : {}}
              >
                
                 {/* ----------------------------------------Block Number Order----------------------------------------------------- */}
                 {i.place.trim() !== "הזמנות למחסן" ? <Disigner i={i} isName={isName}/> : <Storage i={i} isName={isName}/>}
                 {/* ---------------------------------------Button End-------------------------------------------------- */}
                 {Button(ready, () => handleClickEnd(i._id, i.order))}
               </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Manager;
